import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import fr from './fr';
import en from './en';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    fr: fr,
    en: en,
};

i18n.use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: 'en',

        keySeparator: '.',

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
